import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Juan', 'María', 'Carlos', 'Lucía', 'Diego', 'Andrea', 'José', 'Valeria', 'Fernando', 'Gabriela', 'Miguel', 'Camila', 'Renzo', 'Daniela', 'Sebastián', 'Rosa', 'Álvaro', 'Paola', 'Jorge', 'Milagros'];
const CITIES = ['Arequipa', 'Lima', 'Trujillo', 'Cusco', 'Piura', 'Chiclayo', 'Tacna', 'Huancayo', 'Iquitos', 'Cajamarca', 'Ica', 'Puno'];
interface Sale {
  id: number;
  name: string;
  city: string;
}
const rand = (max: number) => Math.floor(Math.random() * max);
function buildSale(id: number): Sale {
  return {
    id,
    name: NAMES[rand(NAMES.length)],
    city: CITIES[rand(CITIES.length)]
  };
}
// Synthesize a subtle "cha-ching" cash-register sound with the Web Audio API
// (no external assets needed). Two quick ascending bell tones.
function playCashSound(ctx: AudioContext | null) {
  if (!ctx) return;
  try {
    if (ctx.state === 'suspended') ctx.resume();
    const now = ctx.currentTime;
    const master = ctx.createGain();
    master.gain.value = 0.16; // keep it subtle
    master.connect(ctx.destination);
    const ding = (freq: number, start: number) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'triangle';
      osc.frequency.setValueAtTime(freq, now + start);
      gain.gain.setValueAtTime(0.0001, now + start);
      gain.gain.exponentialRampToValueAtTime(1, now + start + 0.012);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + 0.32);
      osc.connect(gain);
      gain.connect(master);
      osc.start(now + start);
      osc.stop(now + start + 0.34);
    };
    // Classic register "cha-ching": two bright tones in quick succession
    ding(1318.51, 0); // E6
    ding(1760.0, 0.08); // A6
  } catch {
    /* audio not available — fail silently */
  }
}
export function PurchaseNotifications() {
  const [sale, setSale] = useState<Sale | null>(null);
  const idRef = useRef(0);
  const timeouts = useRef<number[]>([]);
  const audioCtxRef = useRef<AudioContext | null>(null);
  useEffect(() => {
    // Lazily create / unlock the AudioContext on the first user gesture so the
    // browser allows sound playback.
    const unlock = () => {
      if (!audioCtxRef.current) {
        const Ctx = (window as any).AudioContext || (window as any).webkitAudioContext;
        if (Ctx) audioCtxRef.current = new Ctx();
      }
      if (audioCtxRef.current?.state === 'suspended') {
        audioCtxRef.current.resume();
      }
    };
    window.addEventListener('pointerdown', unlock);
    window.addEventListener('keydown', unlock);
    return () => {
      window.removeEventListener('pointerdown', unlock);
      window.removeEventListener('keydown', unlock);
    };
  }, []);
  useEffect(() => {
    const clearAll = () => {
      timeouts.current.forEach(t => clearTimeout(t));
      timeouts.current = [];
    };
    const showNext = () => {
      idRef.current += 1;
      setSale(buildSale(idRef.current));
      playCashSound(audioCtxRef.current);
      // Keep the toast visible for ~5.5s
      const hideT = window.setTimeout(() => {
        setSale(null);
        // Random gap between sales: ~45s to ~80s
        const gap = 45000 + Math.random() * 35000;
        const nextT = window.setTimeout(showNext, gap);
        timeouts.current.push(nextT);
      }, 5500);
      timeouts.current.push(hideT);
    };
    // First notification after a short delay
    const startT = window.setTimeout(showNext, 8000);
    timeouts.current.push(startT);
    return clearAll;
  }, []);
  return <div className="fixed bottom-5 left-5 z-[60] pointer-events-none max-w-[calc(100vw-2.5rem)]" data-id="element-1">
      <AnimatePresence mode="wait" data-id="element-2">
        {sale && <motion.div key={sale.id} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} className="pointer-events-auto flex items-center gap-3 bg-bg-card/95 backdrop-blur-md border border-accent-border rounded-[14px] pl-3 pr-4 py-3 shadow-[0_8px_40px_rgba(0,0,0,0.45),0_0_24px_rgba(0,180,230,0.12)] w-[300px] max-w-full" data-id="element-3">
            <div className="shrink-0 w-9 h-9 rounded-full bg-accent-glow border border-accent-border flex items-center justify-center" data-id="element-4">
              <CheckCircle2 className="w-5 h-5 text-accent" data-id="element-5" />
            </div>
            <div className="min-w-0" data-id="element-6">
              <p className="text-[13px] text-white leading-snug" data-id="element-7">
                <span className="font-[700]" data-id="element-8">{sale.name}</span> en{' '}
                <span className="font-[700]" data-id="element-9">{sale.city}</span> acaba de comprar{' '}
                <span className="text-accent font-[700]" data-id="element-10">VideoInmo AI</span> por
                S/49,90
              </p>
              <p className="text-[11px] text-text-muted mt-0.5" data-id="element-11">
                hace unos segundos · compra verificada
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}